import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/wrappers/Http';
import { EndPoints, PROXIES } from 'src/app/configs';
import * as  _ from 'lodash'

@Injectable({
  providedIn: 'root'
})
export class DataService {
  data: Array<any> = []
  pagedData: Array<Array<any>> = []
  pagedResults: Array<Array<any>> = []
  markets: Array<any> = [];
  marketHeaders: Array<any> = [];
  activeSport: string = '';
  total = 0;
  perpage = 10;
  currentPage = 1;
  pageCount = 0;
  frequency = 5
  pageManager: any;
  results: any[];
  activeSportResult: string;
  sportService: any;
  constructor(private http: HttpService) { }


  public getDashBoardData(params?) {
    var date = new Date();
    let param = { limit: 125, status: true, date: new Date().getTime() }
    return Promise.resolve(this.http.get(EndPoints.data + decodeURIComponent('sr:sport:' + params.sport) + '/games', param).then(data => {
      this.markets = data['markets'];
      this.frequency = params.frequency;
      console.log(this.frequency)
      this.perpage = params.perpage ? params.perpage : this.perpage;
      if (this.markets) {
        this.markets.forEach(market => {
          this.marketHeaders.push(...market.outcomeBeans)
        });
      }
      // Remove events that have already started and are not live, and events with no outcome odds
      const now = Date.now();
      this.data = (data.data || [])
        .filter(match => match.isLive || (match.time && match.time >= now))
        .filter(match => match.outcomes && match.outcomes.some(o => o.odd != null))
        .sort((a, b) => (a.time || 0) - (b.time || 0));
      this.total = this.data.length;
      this.pageCount = Math.ceil(this.total / this.perpage);
      this.pagedData = _.chunk(this.data, this.perpage);
      console.log(this.marketHeaders, this.markets)

      if (this.pageCount > 1 && this.frequency)
        this.startPagerManager();
    }));
  }
  public getLatestResults(params) {
    if (!params.sport)
      return;
    this.results = [];
    this.activeSportResult = 'sr:sport:' + params.sport;
    this.http.Hget(PROXIES.data, 'v1/sport/results/period/' + decodeURIComponent(this.activeSportResult) + '/20', { limit: 20 }).then(data => {
      this.results = data;
      this.pagedResults = _.chunk(data, Math.ceil(data.length/2))
      console.log(this.pagedResults)
    });
  }

  startPagerManager() {
    if (this.pageManager) {
      clearInterval(this.pageManager)
    }
    this.pageManager = setInterval(() => {
      if (this.currentPage == this.pageCount) {
        this.currentPage = 1
      } else {
        this.currentPage = this.currentPage + 1;
      }

    }, this.frequency * 1000);
  }
}
